import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {

  public isUserLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  setLoginStatus() {
    if(localStorage.getItem("userToken") != null)
    {
      this.isUserLoggedIn.next(true);
    }
    else
    {
      this.isUserLoggedIn.next(false);
    }
  }

  constructor() { 
    this.setLoginStatus();
  }
}
